<template>
  <div class="recovery-container">
    <div class="recovery-block">
      <div class="password-recovery" v-if="!isEmailExists">
        <h2 class="heading">Восстановление пароля</h2>
        <form class="form" @submit.prevent="postEmail">
          <div class="form-box">
            <base-label class="label" for="email" :required="true">
              Email
            </base-label>
            <base-input
              id="email"
              class="form-input"
              type="email"
              v-model="email"
              :invalid="errors.email"
              @update:modelValue="errors.email = false"
            />
            <span class="error-message" v-if="errors.email">
              Поле обязательно для заполнения
            </span>
          </div>
          <base-error-container
            class="error-box"
            :error-container-msg="errorContainerMsg"
            v-show="errorContainerMsg.visible"
          />
          <p class="recovery-link-hint" v-if="showRecoveryLink">
            Уже есть код?
            <a @click.prevent="goToPasswordRecovery" href="#">
              Перейти к восстановлению пароля
            </a>
          </p>
          <div class="actions-box">
            <base-primary-button
              class="submit-btn"
              type="submit"
              :disabled="loading"
            >
              {{
                loading
                  ? "Отправка данных..."
                  : "Восстановить аккаунт"
              }}
            </base-primary-button>
            <base-button
              class="cancel-btn"
              type="button"
              @click="goToLogin"
            >
              Отмена
            </base-button>
          </div>
        </form>
      </div>
      <div class="recovery-info" v-else>
        <p class="recovery-desc">
          Отправили письмо со ссылкой на восстановление пароля вам на
          почту.
        </p>
        <base-primary-button @click="goToPasswordRecovery">
          Ввести вручную
        </base-primary-button>
      </div>
    </div>
  </div>
</template>

<script>
import usersApi from "../services/api/usersApi";

export default {
  name: "AccountRecoveryPage",
  extends: {},
  props: {},
  data() {
    return {
      email: "",
      loading: false,
      errorContainerMsg: { visible: false, text: "Возникла ошибка" },
      isEmailExists: false,
      showRecoveryLink: false,
      errors: {
        email: false,
      },
    };
  },
  computed: {},
  components: {},
  watch: {},
  methods: {
    validateForm() {
      this.errors.email = false;

      if (!this.email) {
        this.errors.email = true;
        return false;
      }

      return true;
    },

    async postEmail() {
      this.errorContainerMsg.visible = false;
      this.showRecoveryLink = false;

      if (!this.validateForm()) return;

      this.loading = true;

      try {
        await usersApi.sendRecoveryToken({
          email: this.email,
        });

        this.loading = false;
        this.errorContainerMsg.visible = false;
        this.isEmailExists = true;
      } catch (error) {
        this.loading = false;
        this.errorContainerMsg.visible = true;
        this.errorContainerMsg.text = error.response.data.errors;

        this.showRecoveryLink = error.response.status === 422;
      }
    },

    goToPasswordRecovery() {
      this.$router.push({
        name: "PasswordRecovery",
        query: { email: this.email },
      });
    },

    goToLogin() {
      this.$router.push({ name: "Login" });
    },
  },
  beforeCreate() {},
  mounted() {},
};
</script>

<style scoped>
.recovery-container {
  display: flex;
  justify-content: center;
}

.recovery-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 15vh;
  padding: 50px;
  background-color: var(--color-dark);
  border-radius: 20px;
}

.recovery-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
}

.recovery-desc {
  color: #fff;
}

.heading {
  margin-bottom: 30px;
  color: #fff;
}

.label {
  color: #fff;
}

.error-message {
  display: block;
  margin-top: 5px;
  color: var(--color-danger);
  font-size: 14px;
}

.error-box {
  margin-top: var(--base-in-indent);
  width: 100% !important;
}

.recovery-link-hint {
  margin-top: var(--base-in-indent);
  font-size: 14px;
  color: var(--color-text-secondary, #ccc);
}

.recovery-link-hint a {
  color: var(--color-primary);
  cursor: pointer;
  text-decoration: underline;
}

.actions-box {
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
}

@media (max-width: 768px) {
  .recovery-container {
    height: 100vh;
    background-color: var(--color-dark);
  }
}
</style>
